module.exports = __webpack_public_path__ + "static/media/calling.33cce99.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/calling.ogg
// module id = 50FU
// module chunks = 0